module.exports = __webpack_public_path__ + "media/images/area/feature/banner/pc/en_kyushu-54cf1d1989013e46f5f19094f1135e13.jpg";